Wee.fn.make('faq', {
	init: function() {
		var priv = this.$private;

		priv.initEvents();
	},

	unload: function() {
		$.events.off(false, '.faq');
	}
}, {

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:faqListTitle': {
				'click': function(e, el) {
					var $el = $(el);

					scope.togglePanel($el);
					$el.addClass('-no-outline');
					e.preventDefault();
				},
				'blur': function(e, el) {
					var $el = $(el);

					$el.removeClass('-no-outline');
				},
				'keydown': function(e, el) {
					if (e.keyCode === 13) {
						scope.togglePanel(el);
						e.preventDefault();
					}
				}
			}
		}, {
			namespace: 'faq'
		});
	},

	/**
	 * Toogle Panel
	 *
	 * @private
	 */
	togglePanel: function(el) {
		var $tab = $(el),
			$tabs = $('ref:faqListTitle'),
			$containers = $('ref:faqListItem'),
			$tabPanels = $('ref:tabPanel'),
			$container = $tab.closest('ref:faqListItem'),
			$panel = $container.find('ref:tabPanel');

		$container.toggleActive();

		if ($tab.attr('aria-selected') === 'true') {
			$tab.attr({
				'aria-expanded': 'false',
				'aria-selected': 'false'
			});
			$panel.attr('aria-hidden', 'true');
		} else {
			$containers.not($container).deactivate();
			$tabs.not($tab).attr({
				'aria-expanded': 'false',
				'aria-selected': 'false'
			});
			$tabPanels.not($panel).attr('aria-hidden', 'true');
			$tab.attr({
				'aria-expanded': 'true',
				'aria-selected': 'true'
			});
			$panel.attr('aria-hidden', 'false');
		}
	}
});
